import * as data from './en.json'
import axios from 'axios'
import {getURL} from '../../utils'

export function getLabel (prop, lang) {
  // console.log('[DEBUG] get ', prop, data.installation[prop])
  const value = data.installation[prop]
  if (value == null) {
    return 'Custom property'
  }
  return value
}

export function exportToXls (filtered1, include) {
  if (filtered1.length < 1) {
    return
  }
  let exportContent = []
  const includeKeys = Object.keys(include).map(key => include[key].field);
  const keys = Object.keys(filtered1[0])
    .filter(key => includeKeys.includes(key))
    .sort((a, b) => includeKeys.indexOf(a) - includeKeys.indexOf(b))

  let headers = {}
  include.forEach(item => {
    headers[item.field] = item.label
  })

  filtered1.forEach(p => {
    let row = {}
    keys.forEach(key => {
      row[headers[key]] = p[key]
    })
    exportContent.push(row)
  })

  axios.post(getURL('/api/v1/convert-to-xls'), exportContent, {
    responseType: 'blob',
    headers: {
      'Meta': keys.map(k => headers[k]).join(';')
    }
  })
    .then(res => {
      const href = URL.createObjectURL(res.data)
      let link = document.getElementById('exportXLSLink')
      if (link) {
        link.remove()
      }
      link = document.createElement('a')
      link.href = href
      link.download = 'IB_Export.xlsx'
      link.hidden = true
      link.id = 'exportXLSLink'
      link.innerHTML = 'export to XLS'

      link.click()

      document.body.removeChild(link)
      URL.revokeObjectURL(href)
    })
}

export function exportToCSV (filtered1, include) {
  if (filtered1.length < 1) {
    return
  }
  let exportContent = '"sep=;"\r\n';
  const includeKeys = Object.keys(include).map(key => include[key].field);
  const keys = Object.keys(filtered1[0]).filter(key => includeKeys.includes(key))
    .sort((a, b) => includeKeys.indexOf(a) - includeKeys.indexOf(b))
  let header = keys.map(key => Object.values(include).filter(k => key === k.field).map(it => it.label)[0])

  exportContent = header.join(';')
  exportContent += '\n'
  filtered1.forEach(p => {
    let row = ''
    keys.forEach(key => {
      row += p[key] ? p[key].toString().trim().replaceAll(';', ',') + ';' : ';'
    })
    exportContent += row + '\n'
  })
  let link = document.getElementById('exportCSVLink')
  if (link) {
    link.remove()
  }
  link = document.createElement('a')
  link.hidden = true
  link.id = 'exportCSVLink'
  link.innerHTML = 'export to CSV'
  link.download = 'export.csv'
  // link.href = 'data:text/plain;charset=UTF-8, ' + encodeURIComponent(exportContent)
  link.href = 'data:application/csv, ' + encodeURIComponent(exportContent)

  link.click()
}
